<mat-toolbar color="primary" class="item-panel-toolbar">
    <span>Contact</span>
    <app-contact-type-list [contact]="contact" (selected)="selectType($event)"></app-contact-type-list>
    <app-user-selection style="margin-left: 20px;margin-top: 5px;" (selected)="selectUser($event)" [label]="'Prestataire'" [user]="user" [mode]="'list'" [userClass]="'SNItem.SNUser.CNUser.CNHealthAgent'" [searchUserGroups]="searchUserGroups"></app-user-selection>
    <mat-form-field style="margin-left: 20px;margin-top: 5px;" class="field-medium">
        <mat-label>Date de la consultation</mat-label>
        <input matInput [value]="contact.date" (dateChange)="contact.date = $event.value" [matDatepicker]="pickerEnd">
        <mat-datepicker-toggle matSuffix [for]="pickerEnd"></mat-datepicker-toggle>
        <mat-datepicker #pickerEnd></mat-datepicker>
    </mat-form-field>
    <span class="toolbar-spacer"></span>
    <button mat-icon-button style="margin-top: 9px;">
        <fa-icon (click)="openPrescription()" [icon]="['fas','file-prescription']" [ngClass]="{'contact-have-prescription': contact.havePrescription}" size="2x"></fa-icon>
    </button>
    <button mat-icon-button style="margin-top: 9px;">
        <fa-icon (click)="save()" [icon]="['fas','save']" size="2x"></fa-icon>
    </button>
</mat-toolbar>
<app-contact #contactComponent [contact]="contact"></app-contact>
